import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const LeftArrow = ({ width = "6.295" }) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    viewBox="0 0 6.295 9.801"
  >
    <path
      id="стр"
      d="M5,.328l4.9,4.9-1.4,1.4L5,3.119l-3.5,3.5L.1,5.219,4.986.328,5,.337Z"
      transform="translate(-0.328 9.899) rotate(-90)"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
);

export default LeftArrow;



// WEBPACK FOOTER //
// ./src/components/Icons/Trade/LeftArrow.js